import axios from 'axios';

//const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
import { getConfig } from '../config';
const { API_BASE_URL } = getConfig();
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true,
  timeout: 10000
});

// 재시도 설정
const MAX_RETRIES = 3;
const INITIAL_RETRY_DELAY = 1000;

// 에러 메시지 포맷팅 함수
const formatErrorMessage = (error: any): string => {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      const detail = error.response.data.detail;
      if (typeof detail === 'string') {
        return detail;
      }
      return '서버에서 오류가 발생했습니다.';
    } else if (error.request) {
      if (error.code === 'ECONNABORTED') {
        return '서버 응답 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.';
      }
      return '서버에 연결할 수 없습니다. 네트워크 연결을 확인해주세요.';
    }
    return '요청 처리 중 오류가 발생했습니다.';
  }
  return '알 수 없는 오류가 발생했습니다.';
};

// 재시도 로직
const retryRequest = async (fn: () => Promise<any>, retries = 3, delay = 1000): Promise<any> => {
  try {
    return await fn();
  } catch (error) {
    if (retries === 0) {
      throw error;
    }
    console.log(`재시도 남은 횟수: ${retries}. ${delay}ms 후 재시도합니다.`);
    await new Promise(resolve => setTimeout(resolve, delay));
    return retryRequest(fn, retries - 1, delay * 2);
  }
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('isLoggedIn');
        window.location.href = '/login';
        return Promise.reject(new Error('인증이 만료되었습니다. 다시 로그인해주세요.'));
      }
      
      if (error.response.status === 500) {
        console.error('Server Error:', error.response.data);
        return Promise.reject(new Error('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'));
      }
    }
    
    return Promise.reject(error);
  }
);

export default api; 